module.exports = {"532532101":"河口镇","532532102":"南溪镇","532532201":"老范寨乡","532532202":"桥头苗族壮族乡","532532203":"瑶山乡","532532204":"莲花滩乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532532.json
// module id = 2636
// module chunks = 0